const TARGET_SELECTOR = ".js-typograph";
const NBSP = " ";

const replacePrepositions = text =>
  text
    .replace(
      /(?:^|(?<=[\s([{'”«„””—-]))((?:по|на|в|и|к|из|от|над|для|не|мы|их|при|с|а|у|за))\s+/giu,
      `$1${NBSP}`
    )
    .replace(/(\d+)\s+([A-Za-zА-Яа-яЁё]+)/g, `$1${NBSP}$2`)
    .replace(/\s+(—)/g, `${NBSP}$1`);

const shouldSkipNode = parent =>
  !parent ||
  ["SCRIPT", "STYLE", "CODE", "PRE", "TEXTAREA"].includes(parent.nodeName);

const typographElement = element => {
  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
  const textNodes = [];

  while (walker.nextNode()) {
    const textNode = walker.currentNode;

    if (shouldSkipNode(textNode.parentElement)) continue;
    if (!textNode.nodeValue || !textNode.nodeValue.trim()) continue;

    textNodes.push(textNode);
  }

  textNodes.forEach(node => {
    node.nodeValue = replacePrepositions(node.nodeValue);
  });
};

export const typograph = () => {
  document.querySelectorAll(TARGET_SELECTOR).forEach(typographElement);
};
